import React from "react";

import styles from "./index.module.css";

interface QRCodeProps {
  base64Data?: string;
  ticketNumber?: string;
  attractionName?: string;
  className?: string;
}

const QRCode: React.FC<QRCodeProps> = ({
  base64Data,
  attractionName,
  ticketNumber,
  className,
}) => {
  return (
    <div className={`${styles.qrCodeContainer} ${className || ""}`}>
      <h2 className={styles.title}>
        {attractionName
          ? `Видеобилет для «${attractionName}»`
          : `Видеобилет «${ticketNumber}»`}
      </h2>
      <div className={styles.qrCodeWrapper}>
        {base64Data ? (
          <img
            src={base64Data}
            alt="QR код для билета"
            className={styles.qrCodeImage}
          />
        ) : (
          // Fallback to the placeholder image from Figma
          <img
            src={require("../../resources/images/qr-code.png")}
            alt="QR код для билета"
            className={styles.qrCodeImage}
          />
        )}
      </div>
      <p className={styles.instruction}>Показать инструктору аттракциона</p>
    </div>
  );
};

export default QRCode;
